import React from 'react';
import './FeatureList.css';
import Bullet from '../Bullet';
import { Flex, Typography } from 'antd';
import { getIcon, ICONS } from '../../icons';
import { COLOURS } from '../../colours';
import useMobileCheck from '../../mobile';

const { Title, Paragraph } = Typography;

const FeatureList = ({ heading, items, type = 'list', style, small }) => { 

  const { isMobile } = useMobileCheck();

  if ( type === 'list' ) { 
    return (
      <Flex style={ { ...style } } vertical>
        { small ? <h3>{heading}</h3> : <h2 className="feature-heading">{heading}</h2> }
        <ul className="feature-list">
          {items.map((item) => (
            <Bullet key={item.title} {...item} />
          ))}
        </ul>
      </Flex>
    )
  } else { 
    return (
      <Flex 
        wrap="wrap" gap={ isMobile ? '10px' : '40px' } 
        style={{ '--gap': isMobile ? '10px' : '40px', '--columns': 3, ...style }}
        >
        {items.map((item) => (
          <Flex 
            style={ isMobile ? {
              background: item.heading ? COLOURS.PRIMARY : 'white',
              flexBasis: `calc(100%)`,
              flexShrink: 1,
              borderRadius: '16px',
              padding: '20px',
              minHeight: '220px'
            } : {
              background: item.heading ? COLOURS.PRIMARY : 'white',
              flexBasis: `calc((100% - (var(--gap) * (var(--columns) - 1))) / var(--columns))`,
              flexShrink: 1,
              borderRadius: '16px',
              padding: '20px'
            } }
            key={item.title}
            vertical gap={10}
          >
            { !item.heading && 
              <>
                <Flex
                  align="center"
                  >
                  { getIcon(ICONS.SHUTTLEOPS_SHUTTLE, false, { 
                    kit: true, size: 30 ,
                    primary: COLOURS.PRIMARY,
                    style: { 
                      marginLeft: '-10px'
                    }  
                  } ) }
                  <Title 
                    style={{ 
                      marginTop: '0px'
                    }}
                    level={5}>{ item.title}</Title>
                </Flex>
                <Paragraph>{ item.description }</Paragraph>
              </>
            }
            { item.heading && <Flex
              align='center'
              justify='center'
              style={ { 
                width: '100%',
                height: '100%'  
              }}
              >
              <Title 
                style={{ 
                  marginTop: '0px',
                  color: COLOURS.WHITE,
                  marginBottom: isMobile ? '10px' : '0px'
                }}
                >{ item.title }</Title>
            </Flex>}
          </Flex>
        ))}
      </Flex>
    );
  }
}

export default FeatureList;
